
import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';
import { BASE_URLS } from '../../config/globalConfig';
import ReactWhatsapp from 'react-whatsapp';
import { Link } from 'react-router-dom';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <video autoPlay muted loop playsInline>
                        <source src="/videos/music-learning-boy-guitar.mp4" type="video/mp4" />
                        <source src="/videos/music-learning-boy-guitar.webm" type="video/webm" />
                    </video>
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>H</span>
                                    <span>A</span>
                                    <span>R</span>
                                    <span>S</span>
                                    <span>H</span>
                                    <span>I</span>
                                    <span>T</span>
                                    <span>A</span>
                                    <span>&nbsp;</span>
                                    <span>S</span>
                                    <span>C</span>
                                    <span>H</span>
                                    <span>O</span>
                                    <span>O</span>
                                    <span>L</span>
                                    <span>&nbsp;</span>
                                    <span>O</span>
                                    <span>F</span>
                                    <span>&nbsp;</span>
                                    <span>M</span>
                                    <span>U</span>
                                    <span>S</span>
                                    <span>I</span>
                                    <span>C</span>
                                </div>
                            </h1>
                        </div>
                    </div>
                    <div className="hero-btns-flex">
                        <ReactWhatsapp
                            number={BASE_URLS.CONTACT.WHATSAPP}
                            message="Hello! I would like to request the HSM course brochure. Please send me the detailed information about your music courses. Thank you!"
                            element="button"
                            className="button"
                        >
                            <span>REQUEST BROCHURE</span>
                        </ReactWhatsapp>
                        <Link to="/request-brochure">WhatsApp Us</Link>
                    </div>
                </div>
            </div>
        </>
    );
}